module.exports = __webpack_public_path__ + "static/media/gb-sct.d1d305dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-sct.svg
// module id = 120
// module chunks = 0